module.exports = __webpack_public_path__ + "039f8527394f1612a7432ecd8940bf75.MP3";